import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/httpclient";
import { FederationId, LoginUrl } from "../../settings";

const initialState = {
  pageLoaded: false,
  pageDisposed: true,
  processing: false,
  processingText: "",
  loading: false,
  loaded: false,
  error: null,
  from: null,
};

const loginPageSlice = createSlice({
  name: "loginPage",
  initialState: { ...initialState },
  reducers: {
    setInitialState: (state, action) => ({ ...initialState }),

    setPageLoaded: (state, action) => ({
      ...initialState,
      pageLoaded: true,
      pageDisposed: false,
    }),

    setProcessing: (state, action) => {
      //payload: {processing=true, processingText=false}, when processing is false, processingText is ""
      const { processing = true, processingText = "" } = action.payload;

      return {
        ...state,
        processing: processing,
        processingText: processing == false ? "" : processingText,
      };
    },

    setLoginPage: (state, action) => {
      return { ...action.payload };
    },

    disposePage: (state, action) => {
      //payload: bool
      if (action.payload) return { ...initialState };
      else return { ...state, pageDisposed: false };
    },
  },
});

export const login =
  (username, password, faceId, facePin, t) => async (dispatch, getState) => {
    //show loader
    dispatch(
      setProcessing({ processing: true, processingText: t("slices.signingIn")})
    );

    try {
      var response = await api({
        url: LoginUrl,
        method: "post",
        data: {
          FederationId: FederationId,
          username: username,
          password: password,
          faceId: faceId,
          facePin: facePin,
        },
        //headers:{'h':'1'}
      });

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      if (getState().loginPage.pageDisposed) return;

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      return Promise.reject(err);
    }
  };

export const createUserPasswordResetLink =
  (email, t) => async (dispatch, getState) => {
    //show loader
    dispatch(
      setProcessing({ processing: true, processingText: t("slices.processing")})
    );

    try {
      var response = await api({
        url: "auth/createuserresetpasswordlink",
        method: "post",
        data: {
          email: email,
        },
        //headers:{'h':'1'}
      });

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      if (getState().loginPage.pageDisposed) return;

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      return Promise.reject(err);
    }
  };

export const {
  setPageLoaded,
  setInitialState,
  setLoginPage,
  setProcessing,
  disposePage,
} = loginPageSlice.actions;

export default loginPageSlice.reducer;
